import { z } from 'zod';

import { emailSchema, textoCurtoSchema } from './common.js';

export const usuarioRoleSchema = z.enum(['admin', 'vendedor', 'aprovador']);

export const criarUsuarioSchema = z.object({
  email: emailSchema,
  entraObjectId: z.string().uuid(),
  nome: textoCurtoSchema,
  roles: z.array(usuarioRoleSchema).min(1),
  empresa: textoCurtoSchema.optional(),
});

export type CriarUsuarioInput = z.infer<typeof criarUsuarioSchema>;

export const atualizarUsuarioSchema = z.object({
  nome: textoCurtoSchema.optional(),
  roles: z.array(usuarioRoleSchema).min(1).optional(),
  empresa: textoCurtoSchema.optional(),
  ativo: z.boolean().optional(),
});

export type AtualizarUsuarioInput = z.infer<typeof atualizarUsuarioSchema>;
